import React from 'react';
import './Solutions.css';
import playbookBuilder from '../images/Product page - Playbook Builder.png';
import taskList from '../images/Product page - Task List.png';
import budgetCalc from '../images/Product Page - Budget & ROI Calculator.png';
import aiStrategy from '../images/AI Enhanced Guided Strategy.png';
import CTASection from '../components/CTASection';

function Solutions() {
  return (
    <div className="solutions-page">
      <section className="solutions-hero">
        <div className="hero-content">
          <p className="hero-tagline">Zibit helps your team plan smarter, execute better, and prove results.</p>
          <h1>All-in-One Trade Show Management. Done Right.</h1>
          <button className="cta-button">Get Started</button>
        </div>
      </section>

      <section className="features-overview">
        <div className="content-container">
          <h2>Features Overview</h2>
          <p className="overview-text">
            Managing trade shows is often complex and disorganized, relying on multiple platforms, 
            manual processes, and fragmented information. Key challenges include tracking event details, 
            coordinating inventory and shipping for overlapping events, and lacking industry best practices. 
            Additionally, trade shows involve significant costs, but measuring ROI and demonstrating success 
            to stakeholders remains difficult. Zibit takes the guesswork and uncertainty out of managing trade shows.
          </p>

          <div className="quiz-banner">
            <p>Is your trade-show spend pulling its weight?</p>
            <p className="quiz-cta">Take our 2-minute ROI Quiz and get your score now.</p>
            <div className="quiz-link">Take Quiz 📋</div>
          </div>
        </div>
      </section>

      <section className="feature-details">
        <div className="content-container">
          <div className="feature-item">
            <img src={playbookBuilder} alt="Playbook Builder" className="feature-image" />
            <div className="feature-text">
              <h3>AI Powered Strategy Builder</h3>
              <p>
                Our playbook builder compiles a comprehensive tactical and strategic plan for each 
                event into one document with the press of a button. Every detail for everyone involved 
                in the event is outlined in a simplified way eliminating the need to field questions 
                from staff members and an outlined plan of attack for execution.
              </p>
            </div>
          </div>

          <div className="feature-item reverse">
            <div className="feature-text">
              <h3>Task List</h3>
              <p>
                Keep track of every minute detail including pre and post marketing, in order to 
                stay on task for each show throughout the year. Overlap with all shows and sort 
                in date order to prioritize the most urgent tasks by deadline across all shows.
              </p>
            </div>
            <img src={taskList} alt="Task List" className="feature-image" />
          </div>

          <div className="feature-item">
            <img src={budgetCalc} alt="Budget Calculator" className="feature-image" />
            <div className="feature-text">
              <h3>Budget & ROI Calculator</h3>
              <p>
                Stay on target with our individual event and annual budget trackers. Reconcile 
                each show with your success metrics and feel confident in your reporting to key 
                stakeholders with our budget and ROI calculators.
              </p>
            </div>
          </div>

          <div className="feature-item reverse">
            <div className="feature-text">
              <h3>Streamlined Communication</h3>
              <p>
                Access 20 years of trade show success theories and supportive exhibit data to 
                develop smarter show plans that drive success, make smarter decisions and 
                personalize your plans based on your company's unique needs.
              </p>
            </div>
            <img src={aiStrategy} alt="AI Strategy" className="feature-image" />
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}

export default Solutions;